module.exports = __webpack_public_path__ + "static/img/168.5f83028.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/index/168.png
// module id = 1167
// module chunks = 18